import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

/**
 * Aba "Gestão de clientes" da tela Operar Cliente (Área do Contador).
 *
 * Wrapper fino que reusa a tela COMPLETA de clientes (`app-clientes`) em modo
 * EMBUTIDO, sob o contexto do cliente (`X-Empresa-Contexto` injetado pelo
 * interceptor). Assim o contador consulta, ADICIONA e EDITA os clientes do seu
 * cliente com o mesmo formulário/lista da tela de Clientes. Excluir e ações que
 * saem do contexto ficam de fora.
 *
 * A tela carrega a lista no `ngOnInit`, então para SEMPRE refletir o cliente
 * atual ela é RE-MONTADA ao ABRIR a aba e ao TROCAR de cliente.
 */
@Component({
  selector: 'app-operar-clientes',
  templateUrl: './operar-clientes.component.html',
  styleUrls: ['./operar-clientes.component.scss'],
})
export class OperarClientesComponent implements OnChanges {
  /** Id da empresa do cliente — muda quando o contador troca de cliente. */
  @Input() clienteEmpresaId?: number | null;

  /** Indica se a aba está ativa; monta o componente pesado quando a aba abre. */
  @Input() ativo = false;

  /** Controla a existência do componente pesado (montagem sob demanda + re-mount). */
  montado = false;

  ngOnChanges(changes: SimpleChanges): void {
    const abriuAgora =
      !!changes['ativo'] && this.ativo && changes['ativo'].previousValue !== true;
    const trocouCliente =
      !!changes['clienteEmpresaId'] && !changes['clienteEmpresaId'].firstChange;

    if (changes['ativo'] && !this.ativo) {
      this.montado = false;
      return;
    }

    if (abriuAgora || (trocouCliente && this.ativo)) {
      if (this.montado) {
        this.montado = false;
        Promise.resolve().then(() => {
          this.montado = true;
        });
      } else {
        this.montado = true;
      }
    }
  }
}
